<template>
  <div class="flex justify-end gap-x-[12px] p-[24px] sm:px-[40px]">
    <Button
      v-if="type === 'update'"
      :loading="deleting"
      :disabled="deleting"
      variant="tertiary"
      size="md"
      @click="deleteRule"
    >
      Delete
    </Button>

    <Button
      :loading="saving"
      :disabled="saving"
      size="md"
      @click="saveRule"
    >
      Save
    </Button>
  </div>
</template>

<script>
export default {
  name: 'RulesFooter',
  inject: ['type', 'saving', 'deleting', 'saveRule', 'deleteRule'],
};
</script>
